import React from 'react';

function About(){
    return(
        <section className="section">
      <h2>About Us</h2>
      <div className="section-divider"></div>
      <p>At Ratna Vastra, we specialize in offering a curated range of women’s wear
including traditional sarees, elegant festive outfits, and stylish everyday dresses.
Our focus is on quality, comfort, and sophistication.
Each product is selected with care to ensure that you feel beautiful and confident
whenever you wear it.
Discover fashion that matches your personality — Graceful. Stylish. Timeless.</p>
    </section>

    

    );
}
export default About;